<div class="card">
  @if (title) {
    <app-section-title [title]="title" [icon]="icon"></app-section-title>
    <!-- <h3 class="card-title" [class.centered]="centerTitle">{{ title }}</h3> -->
  }
  <!-- Carousel -->
  @if (type === 'carousel') {
    <div class="carousel-wrapper" [style.width]="width" [style.height]="height">
      <button
        irxBotonIcono="imagen"
        class="arrow left"
        tooltip="Anterior"
        (click)="prevImage()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="carousel-image-container">
        <img [src]="images[currentImageIndex]" alt="Imagen carrusel" />
      </div>
      <button
        irxBotonIcono="imagen"
        class="arrow right"
        tooltip="Siguiente"
        (click)="nextImage()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }

  <!-- Horizontal Table -->
  @if (type === 'horizontal-table') {
    <div>
      <mat-table
        [dataSource]="horizontalDataSource"
        class="mat-elevation-z2"
        [style.box-shadow]="!boxShadow ? 'none' : 'default'"
      >
        <ng-container matColumnDef="key">
          <mat-cell *matCellDef="let element">{{ element.key }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="value">
          <mat-cell *matCellDef="let element">
            <div class="value-container">
              <!-- Botón de copia al portapapeles -->
              @if (isCopyableField(element.key) && element.value) {
                <button
                  irxBotonIcono
                  tamano="mini"
                  (click)="copyToClipboard(element.value)"
                  tooltip="Copiar al portapapeles"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              }

              <div
                [class.no-info]="
                  element.value === null || element.value === undefined
                "
                [innerHTML]="
                  getSafeHtml(
                    element.value ||
                      alternativeValues[element.key] ||
                      'Sin información'
                  )
                "
              ></div>

              <!-- Mostrar valor alternativo si el valor es vacío o inexistente -->
              <!-- <span
                [class.no-info]="
                  element.value === null || element.value === undefined
                "
              >
                {{
                  element.value ||
                    alternativeValues[element.key] ||
                    'Sin información'
                }}
              </span> -->
            </div>
          </mat-cell>
        </ng-container>
        <mat-row
          *matRowDef="
            let row;
            columns: horizontalDisplayedColumns;
            trackBy: trackByRow
          "
        ></mat-row>
      </mat-table>
    </div>
  }

  <!-- Vertical Table -->
  @if (type === 'vertical-table') {
    <div>
      <mat-table
        [dataSource]="verticalDataSource"
        class="mat-elevation-z2"
        [style.box-shadow]="!boxShadow ? 'none' : 'default'"
      >
        @for (
          column of verticalDisplayedColumns;
          track trackByColumn($index, column)
        ) {
          <ng-container [matColumnDef]="column">
            <mat-header-cell *matHeaderCellDef>
              <h3>{{ headerLabels[column] || column }}</h3>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <!-- Mostrar valor alternativo si el valor es vacío o inexistente -->
              <span [class.no-info]="!element[column]">
                {{
                  element[column] ||
                    alternativeValues[column] ||
                    'Sin información'
                }}
              </span>
            </mat-cell>
          </ng-container>
        }
        <mat-header-row
          *matHeaderRowDef="verticalDisplayedColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="
            let row;
            columns: verticalDisplayedColumns;
            trackBy: trackByRow
          "
        ></mat-row>
      </mat-table>
    </div>
  }

  <!-- Text Content -->
  @if (type === 'text') {
    <div class="info-text" [class.no-info]="noInfo">
      <p>{{ text }}</p>
    </div>
  }
</div>
